import React, { useEffect } from 'react'
import { Modal, Form, Input, Select, DatePicker, message } from 'antd'
import dayjs from 'dayjs'
import { useProjectTasks } from '../../hooks/useProjectTasks'

const { Option } = Select

const TaskModal = ({ visible, task, projectId, onClose, onSuccess }) => {
  const [form] = Form.useForm()
  const { createTask, updateTask } = useProjectTasks(projectId)

  useEffect(() => {
    if (task) {
      form.setFieldsValue({
        task_title: task.task_title,
        task_description: task.task_description,
        status: task.status,
        due_date: task.due_date ? dayjs(task.due_date) : null,
      })
    } else {
      form.resetFields()
    }
  }, [task, form])

  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      let result
      if (task) {
        result = await updateTask(task.id, values)
      } else {
        result = await createTask(values)
      }

      if (result.success) {
        message.success(task ? 'แก้ไขงานสำเร็จ' : 'สร้างงานสำเร็จ')
        onSuccess()
      } else {
        message.error(result.message || 'เกิดข้อผิดพลาด')
      }
    } catch (error) {
      console.log('Validation Failed:', error)
    }
  }

  return (
    <Modal
      title={task ? 'แก้ไขงาน' : 'สร้างงานใหม่'}
      visible={visible}
      onOk={handleOk}
      onCancel={onClose}
      destroyOnClose
      okText="บันทึก"
      cancelText="ยกเลิก"
    >
      <Form form={form} layout="vertical">
        <Form.Item name="task_title" label="หัวข้อ" rules={[{ required: true, message: 'กรุณากรอกหัวข้อ' }]}>
          <Input />
        </Form.Item>

        <Form.Item name="task_description" label="รายละเอียด">
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item name="status" label="สถานะ" rules={[{ required: true }]}>
          <Select>
            <Option value="todo">งานที่ต้องทำ</Option>
            <Option value="in_progress">กำลังดำเนินการ</Option>
            <Option value="testing">ทดสอบ</Option>
            <Option value="done">เสร็จสิ้น</Option>
          </Select>
        </Form.Item>

        <Form.Item name="due_date" label="กำหนดส่ง">
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default TaskModal
